export { CONFIGROUTES } from './config-menu-items';
export { PHARMACYROUTES } from './pharmacy-menu-items';
export { PATIENTROUTES } from './patient-menu-items';
export { MYWORKSGROUTES } from './my-works-menu-items';
